import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2";
import './sorteo.css';
import { FaTrash } from 'react-icons/fa';
import { FcPuzzle } from "react-icons/fc";
import { FcPlus } from "react-icons/fc";
import { FcViewDetails } from "react-icons/fc";
import { FcCheckmark } from "react-icons/fc";
import { FcAlarmClock } from "react-icons/fc";
import { FcBiohazard } from "react-icons/fc";
import { FcBullish } from "react-icons/fc";





const Sorteo = ({ data, socket, board }) => {
    const [dataSorteo, setDataSorteo] = useState({})
    const [mostrarInfo, setMostrarInfo] = useState(false); // Estado para mostrar/ocultar la tarjeta
    const [porcentaje, setPorcentaje] = useState(0)
    const [arryPuestos, setArryPuestos]=useState([])
    
    useEffect(()=>{
        if(data){
            setDataSorteo(data)
            setArryPuestos(data.arryPuestos)
        }
    },[data])
    const filtrarArray = (array) => {
        return array.filter(obj => {
            // Obtener el valor del único par clave-valor en el objeto
            const valor = Object.values(obj)[0];
    
            // Filtrar aquellos objetos cuyo valor sea exactamente ''
            return valor === '';
        });
    };
    
    useEffect(()=>{
        const cantVendido = arryPuestos.length - filtrarArray(arryPuestos).length;
        setPorcentaje((cantVendido * 100)/dataSorteo.puestos)
        
    },[arryPuestos])

    const PlantillaExpress = () =>{
        board.setDataBoard(data)
        board.setBoard('plantillaWhatsapp')
    }
    const eliminar = async () => {
        // Mostrar mensaje de confirmación
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "Al eliminar este sorteo, se perderá todo el proceso de participación. Es recomendable finalizar el sorteo antes de eliminarlo.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
        });
        if (result.isConfirmed) {
            socket.emit('eliminarSorteo',dataSorteo.id)
        }
        //await eliminarDocumento("sorteos", data.id);
    }
    const Iniciar = async()=>{
       
        const ahora = new Date();
  
        // Añadir 30 minutos a la hora actual para establecer el mínimo
        // const tiempoMinimo = new Date(ahora.getTime() + 1 * 60000); // 30 minutos en milisegundos
        const tiempoMinimo = new Date(ahora.getTime() ); // 30 minutos en milisegundos

        // Formatear la fecha mínima en formato 'YYYY-MM-DDTHH:MM' basado en la zona horaria local
        const formatoLocal = tiempoMinimo.toLocaleString('sv-SE', { 
            year: 'numeric', 
            month: '2-digit', 
            day: '2-digit', 
            hour: '2-digit', 
            minute: '2-digit', 
            second: '2-digit',
            hour12: false 
        }).replace(' ', 'T').slice(0, 16); // Convierte a formato 'YYYY-MM-DDTHH:MM'

        const { value: fecha } = await Swal.fire({
            title: 'Selecciona la fecha y hora del sorteo',
            html: `<input type="datetime-local" id="fechaSorteo" class="swal2-input" placeholder="Selecciona fecha y hora" min="${formatoLocal}">`,
            focusConfirm: false,
            preConfirm: () => {
            const fechaSorteo = document.getElementById('fechaSorteo').value;
            const seleccionada = new Date(fechaSorteo);

            // Validar que se ha seleccionado una fecha válida y que es futura
            if (!fechaSorteo) {
                Swal.showValidationMessage('Por favor, selecciona una fecha y hora válidas');
                return null;
            }

            if (seleccionada <= tiempoMinimo) {
                Swal.showValidationMessage('La fecha debe ser al menos 30 minutos en el futuro');
                return null;
            }

            return fechaSorteo;
            },
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
        });

        if (fecha) {
            socket.emit('iniciarSorteo',{id:dataSorteo.id,fecha:fecha})
        }
    }
    // Función para alternar el estado de visibilidad de la tarjeta
    const toggleInfo = () => {
        setMostrarInfo(!mostrarInfo);
    }
    const AgregarParticipante = async()=>{
        board.setDataBoard(data)
        board.setBoard('agregarExpress')
    }
    const listoExpress = (bol)=>{
        console.log('se emitio listoExpress')
        socket.emit('listoExpress',{id:data.id, bol})
    }
    const iniciarExpress = ()=>{
        console.log('se emitio inicioExpress')
        socket.emit('inicioExpress',{id:data.id})
    }
    const ResetExpress = ()=>{
        console.log('se emitio ResetExpress')
        socket.emit('resetExpress',{id:data.id})
    }
    return (
        <div className="sorteo-item">
            {/* Se muestra el ID del sorteo y se agrega un evento de clic para desplegar la tarjeta */}
            <div className={`sorteo-header-${dataSorteo.estado}`} onClick={toggleInfo}>
            {/* <div className={porcentaje===100 ? "sorteo-header-100": "sorteo-header"} onClick={toggleInfo}> */}
                {dataSorteo.typeLot === 'Express'
                    ? <h3>{dataSorteo.premio} {dataSorteo.premioBase}</h3>
                    : <h3>{dataSorteo.premio} {porcentaje}%</h3>
                }
                
            </div>
        
            {/* Información del sorteo que se despliega/oculta según el estado */}
            {mostrarInfo && (
                <div className="sorteo-info">
                    <div className="tarjeta">
                        <img src={dataSorteo.urlImg} alt={`Imagen del sorteo ${dataSorteo.nombre}`} className="sorteo-img" />
                        <table className="sorteo-details">
                            <tbody>
                                <tr>
                                    <th>Id</th>
                                    <td>{dataSorteo.id}</td>
                                </tr>
                                <tr>
                                    <th>Estado</th>
                                    <td>{dataSorteo.estado}</td>
                                </tr>
                                {dataSorteo.estado==='Completado' && (
                                    <tr>
                                        <th>Fecha y hora</th>
                                        <td>{dataSorteo.fecha}</td>
                                    </tr>
                                )}
                                {dataSorteo.estado==='Realizado' && (
                                    <tr>
                                        <th>Ganador</th>
                                        <td>#{dataSorteo.ganador}</td>
                                    </tr>
                                )}
                                <tr>
                                    <th>Venta:</th>
                                    <td>{porcentaje}%</td>
                                </tr>
                                {dataSorteo.typeLot === 'Express'
                                    ? 
                                        <tr>
                                            <th>Premio Acumulado</th>
                                            <td>{dataSorteo.premioBase}</td>
                                        </tr>
                                    :
                                        <tr>
                                            <th>Premio</th>
                                            <td>{dataSorteo.premio}</td>
                                        </tr>
                                }
                                <tr>
                                    <th>Valor:</th>
                                    <td>${dataSorteo.valor}</td>
                                </tr>
                                <tr>
                                    <th>Puestos:</th>
                                    <td>{dataSorteo.puestos}</td>
                                </tr>
                                <tr>
                                    <th>Opciones:</th>
                                    <td>
                                        <FaTrash size={45} style={{ marginRight: 10 }} onClick={eliminar} />
                                        {porcentaje===100 ? <FcPuzzle size={50} style={{ marginRight: 10 }} onClick={Iniciar}/>:''} 
                                        <FcViewDetails size={50} style={{ marginRight: 10 }} onClick={PlantillaExpress}/> 
                                        <FcPlus size={50} style={{ marginRight: 10 }}onClick={AgregarParticipante}/>
                                        {dataSorteo.listo ? <FcBullish  size={50} style={{ marginRight: 10 }}onClick={()=>listoExpress(false)}/>:<FcAlarmClock size={50} style={{ marginRight: 10 }}onClick={()=>listoExpress(true)}/>}
                                        
                                        
                                        <FcCheckmark  size={50} style={{ marginRight: 10 }}onClick={iniciarExpress}/>
                                        <FcBiohazard   size={50} style={{ marginRight: 10 }}onClick={ResetExpress}/>
                                        
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Sorteo;
